import { SortDirection } from 'mbs-ui-kit';

export function getOdataOrderBy(column: string, direction: SortDirection, extra?: string): string | null {
  if (!direction) return null;

  const orderBy = `${column} ${direction}`;

  return extra?.trim() ? `${orderBy}, ${extra}` : orderBy;
}
